/**
 * Client-side notification storage utilities
 * Manages unread notification count in localStorage
 */

const UNREAD_COUNT_KEY = "vocly_unread_count";

/**
 * Get the current unread notification count from localStorage
 * @returns The unread count, or 0 if not set or unavailable
 */
export function getUnreadCount(): number {
  if (typeof window === "undefined") {
    return 0;
  }

  try {
    const count = localStorage.getItem(UNREAD_COUNT_KEY);
    if (count === null) {
      return 0;
    }
    const parsed = parseInt(count, 10);
    return isNaN(parsed) ? 0 : Math.max(0, parsed);
  } catch (error) {
    console.error("Failed to get unread count from localStorage:", error);
    return 0;
  }
}

/**
 * Set the unread notification count in localStorage
 * @param count The new unread count (must be >= 0)
 */
export function setUnreadCount(count: number): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const validCount = Math.max(0, Math.floor(count));
    localStorage.setItem(UNREAD_COUNT_KEY, validCount.toString());
  } catch (error) {
    console.error("Failed to set unread count in localStorage:", error);
  }
}

/**
 * Increment the unread notification count by 1
 */
export function incrementUnreadCount(): void {
  const current = getUnreadCount();
  setUnreadCount(current + 1);
}
